<template>
    <Header
        :elements="countElements"
        :current="countElements"
    ></Header>
    <ThankYou></ThankYou>
</template>

<script>
import ThankYou from '@/components/blocks/ThankYou.vue'
import Header from '@/components/Header-Short-New.vue'
import http from "@/api/http";
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        ThankYou
    },
    data() {
        return {
            classes: []
        }
    },
    mounted() {
        this.init()
        to_top()
    },
    methods: {
        async init() {
            let { data } = await http.get('trademark-renewal/step-thank-you/' + this.$route.params.key);

            if (data.res) {
                this.classes = data.data.data.classes

                if (data.data.data.status != 'C' || data.data.data.status_payment != 'Y') {
                    this.$router.push({ path: '/trademark-renewal/step-2/' + this.$route.params.key })
                }

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
    },
    computed: {
        countElements() {
            return this.classes.length ? 6 + (this.classes.length * 2) : 0
        }
    }
}
</script>
